import React, { useMemo, useState } from "react";
import ReactSelect from "react-select";
import styled from "styled-components";

const Bar = styled.div`
    padding: 2px 0;
    width: 100%;
    overflow-x: auto;
`;

const FiltersList = styled.ul`
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    list-style: none;
    margin: 0;
    padding: 0;
    width: 40%;
`;

const FilterItem = styled.li`
    && {
        display: flex;
        flex-direction: column;
        gap: 1px;
        font-size: 13px;
        padding: 4px;
        border-radius: 4px;
        background-color: ${({ $active }) => ($active ? "#5498ff54" : "transparent")} !important;
        flex: 0 0 220px;
    }

    ${({ $isSingle }) =>
        $isSingle
            ? `
        flex: 0 0 260px;
        max-width: 260px;
        min-width: 130px;
    `
            : `
        flex: 1 1 170px;
        min-width: 130px;
    `}
`;

const FilterLabel = styled.span`
    font-size: 13px;
    font-weight: 500;
    color: #555;
    line-height: 2;
`;

const selectStyles = {
    container: base => ({
        ...base,
        width: "100%",
        minWidth: "130px",
        zIndex: 5
    }),
    menu: base => ({
        ...base,
        zIndex: 9999,
        fontSize: 13
    }),
    menuPortal: base => ({
        ...base,
        zIndex: 99999
    }),
    control: base => ({
        ...base,
        minHeight: 24,
        fontSize: 12,
        lineHeight: 1.2,
        paddingTop: 0,
        paddingBottom: 0
    }),
    valueContainer: base => ({
        ...base,
        paddingTop: 0,
        paddingBottom: 0
    }),
    indicatorsContainer: base => ({
        ...base,
        height: 24
    }),
    dropdownIndicator: base => ({
        ...base,
        paddingTop: 2,
        paddingBottom: 2
    }),
    clearIndicator: base => ({
        ...base,
        paddingTop: 2,
        paddingBottom: 2
    })
};

const IMAGE_YES_NO_ALL = [
    { value: null, label: "All" },
    { value: "true", label: "Yes" },
    { value: "false", label: "No" }
];

export const TableTopMoreFilters = ({ viewOnly, hasImageFilter, tableParams = {}, filterByAnyKey }) => {
    const disableAll = viewOnly;

    const isFilterActive = key => {
        const v = tableParams[key];
        return v !== null && v !== undefined && v !== "" && v !== "all";
    };

    const imageValue = IMAGE_YES_NO_ALL.find(opt => opt.value === (tableParams.image_or_not ?? null)) || IMAGE_YES_NO_ALL[0];

    const menuPortalTarget = typeof document !== "undefined" ? document.body : null;

    return (
        <Bar>
            <FiltersList>
                {hasImageFilter && (
                    <FilterItem $active={isFilterActive("image_or_not")}>
                        <FilterLabel>Image Present</FilterLabel>
                        <ReactSelect
                            styles={selectStyles}
                            menuPortalTarget={menuPortalTarget}
                            classNamePrefix="react-select"
                            options={IMAGE_YES_NO_ALL}
                            value={imageValue}
                            onChange={opt => filterByAnyKey?.("image_or_not", opt ? opt.value : null)}
                            isDisabled={disableAll}
                            placeholder="Select"
                        />
                    </FilterItem>
                )}
            </FiltersList>
        </Bar>
    );
};
